const config = {
  403: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg',
    title: '403',
    desc: 'Та энэ хуудсанд хандах эрхгүй байна',
  },
  404: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg',
    title: '404',
    desc: 'Таны хайсан хуудас олдсонгүй',
  },
  500: {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg',
    title: '500',
    desc: 'Хѳгжүүлэлт хийгдэж байна',
  },
};

export default config;



// WEBPACK FOOTER //
// ./src/components/Exception/typeConfig.js